import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyKeyIndicatorsTitle = styled(Typography, {
    name: 'KeyIndicatorsTitle',
})({
    variant: 'h4',
    fontWeight: '500',
});

export default StyKeyIndicatorsTitle;
